module.exports = __webpack_public_path__ + "img/flag_fi.2eaea04.svg";